import { RolesAndPermissions } from '@shared/constants/roles-and-permissions';
import { VtSettingsListGroupLink } from '@shared/interfaces/settings-list-group-link';
import { HardwareDevicesSettingsRouteName } from '@pages/settings-page/settings-route-names';

export const hardwareDevicesMenuItemTitle = 'Settings.HardwareDevices';

export const hardwareDevicesMenuItemLinks: VtSettingsListGroupLink[] = [
  {
    label: 'Settings.HardwareDevices.ViaTracksTrackers',
    routerLink: HardwareDevicesSettingsRouteName.Trackers,
    permissions: [RolesAndPermissions.TrackerSettingsRead],
  },
  {
    label: 'Settings.HardwareDevices.Find',
    routerLink: HardwareDevicesSettingsRouteName.FindTags,
    permissions: [RolesAndPermissions.FindSettingsRead],
  },
  {
    label: 'Settings.HardwareDevices.Keyfob',
    routerLink: HardwareDevicesSettingsRouteName.Keyfobs,
    permissions: [RolesAndPermissions.KeyfobSettingsRead],
  },
  {
    label: 'Settings.HardwareDevices.CardReaders',
    routerLink: HardwareDevicesSettingsRouteName.CardReaders,
    permissions: [RolesAndPermissions.CardReaderSettingsRead],
  },
];
